export default {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Produkter, Sælgere, QC & Købsguider',
  navSpreadsheet: 'Spreadsheet',
  navCategories: 'Kategorier',
  navProducts: 'Produkter',
  navReviews: 'Anmeldelser',
  navShipping: 'Forsendelse',
  navCoupons: 'Kuponer',
  navWarehouse: 'Lager',
  navQC: 'QC',
  navGuides: 'Guider',
  navSafety: 'Sikkerhed',
  navBlog: 'Blog',
  navAbout: 'Om',
  navContact: 'Kontakt',
  languageSelector: 'Sprog',
  ctaExplore: 'Udforsk Spreadsheet',
  ctaBuyNow: 'Køb Nu',
  ctaMainWebsite: 'Besøg Hovedsiden',
  ctaBrowseGuides: 'Gennemse Guider',
  heroTitle: 'AllChinaBuy Spreadsheet',
  heroSubtitle: 'Find Produkter, Sælgere & Købsressourcer Hurtigere',
  heroDescription: 'Opdag nyttige produktlister, sælgerressourcer, QC-guides, forsendelsesinformation og købstips i ét organiseret AllChinaBuy spreadsheet-hub.',
  trustLine: 'Opdaterede ressourcer • Praktiske guider • Produktresearch • Købs- og forsendelsesinformation',
  whatIsTitle: 'Hvad er AllChinaBuy Spreadsheet?',
  whatIsDesc: 'AllChinaBuy Spreadsheet er en bekvem måde at organisere og udforske produktressourcer, sælgerinformation, købsguider og relateret research på. Vores mål er at gøre produktdiscovery og købsresearch nemmere ved at samle nyttige ressourcer i ét søgbart hub.',
  exploreResources: 'Udforsk AllChinaBuy Ressourcer',
  popularCategories: 'Populære AllChinaBuy Spreadsheet Kategorier',
  latestGuides: 'Seneste AllChinaBuy Guider',
  shippingCost: 'AllChinaBuy Forsendelse & Omkostningsguider',
  shippingCostDesc: 'Lær om forsendelsesmetoder, omkostningsfaktorer, leveringsbetrækninger og praktiske researchtips for dine AllChinaBuy-ordrer.',
  reviewTitle: 'AllChinaBuy Anmeldelse & Legitimitetsguide',
  reviewDesc: 'Find neutral information om platformoplevelse, sikkerhedsbetrækninger, konto-sikkerhed, betalingsbevidsthed og hvordan brugere kan verificere information uafhængigt.',
  compareTitle: 'Sammenlign Før Du Køber',
  compareDesc: 'Brug sammenligningstabeller til at evaluere sælgere, produkter, forsendelsesmuligheder, QC-standarder, priser, lagre, kuponer og købsmetoder.',
  safetyTitle: 'Bliv Sikker Ved Shopping',
  safetyDesc: 'Lær essentielle sikkerhedstips og bedste praksis for online shopping. Besøg vores Sikkerhedscenter for detaljeret vejledning.',
  finalCTATitle: 'Klar til at Udforske AllChinaBuy Spreadsheet?',
  finalCTADesc: 'Gennemse vores seneste spreadsheet-ressourcer, guider, sammenligninger og købsinformation.',
  footerRights: 'Alle rettigheder forbeholdes.',
  footerDisclaimer: 'Dette site er et uafhængigt ressourcehub. Al information er udelukkende til researchformål.',
  footerLinks: 'Hurtige Links',
  footerResources: 'Ressourcer',
  footerLegal: 'Juridisk',
  footerSitemap: 'Sitemap',
  footerPrivacy: 'Privatlivspolitik',
  footerTerms: 'Brugsbetingelser',
  readMore: 'Læs Mere',
  updated: 'Opdateret',
  resourceSpreadsheet: 'AllChinaBuy Spreadsheet',
  resourceReviews: 'AllChinaBuy Anmeldelser',
  resourceShipping: 'AllChinaBuy Forsendelsesomkostning',
  resourceWarehouse: 'AllChinaBuy Lager',
  resourceCoupons: 'AllChinaBuy Kuponer',
  resourceDiscounts: 'AllChinaBuy Rabatkoder',
  resourceLegit: 'AllChinaBuy Legit & Sikkerhed',
  resourceQC: 'AllChinaBuy QC Guider',
  categoryClothing: 'Tøj',
  categoryShoes: 'Sko',
  categoryAccessories: 'Tilbehør',
  categoryElectronics: 'Elektronik',
  categoryBags: 'Tasker',
  categoryStreetwear: 'Streetwear',
  categoryHome: 'Hjem & Livsstil',
  categoryPopular: 'Populære Fund',
  categorySellers: 'Pålidelige Sælgere',
  categoryQC: 'QC Ressourcer',
  aboutTitle: 'Om AllChinaBuy Spreadsheet',
  aboutDesc: 'Vi er et uafhængigt ressourcehub dedikeret til at hjælpe købere med at researche og organisere AllChinaBuy produktinformation.',
  contactTitle: 'Kontakt Os',
  contactDesc: 'Har du spørgsmål eller forslag? Vi vil gerne høre fra dig.',
  safetyCenter: 'Sikkerhedscenter',
  safetyCenterDesc: 'Essentielle sikkerhedstips og bedste praksis for online shopping og research.',
  allchinabuySpreadsheet: 'AllChinaBuy spreadsheet',
  allchinabuyReview: 'AllChinaBuy review',
  allchinabuyShipping: 'AllChinaBuy shipping cost',
  allchinabuyCoupon: 'AllChinaBuy coupon',
  allchinabuyDiscount: 'AllChinaBuy discount code',
  allchinabuyWarehouse: 'AllChinaBuy warehouse',
  allchinabuyLegit: 'AllChinaBuy legit',
  allchinabuyQC: 'AllChinaBuy QC',
  allchinabuySellers: 'AllChinaBuy sellers',
  allchinabuyProducts: 'AllChinaBuy products',
  allchinabuyGuide: 'AllChinaBuy buying guide',
  breadcrumbHome: 'Hjem',
  breadcrumbBlog: 'Blog',
  breadcrumbAbout: 'Om',
  breadcrumbContact: 'Kontakt',
  breadcrumbSafety: 'Sikkerhed',
  metaHomeTitle: 'AllChinaBuy Spreadsheet – Produkter, Sælgere, QC & Købsguider',
  metaHomeDesc: 'Udforsk AllChinaBuy Spreadsheet med produktlister, sælgerressourcer, QC-guides, forsendelsesinformation, anmeldelser, kuponer og praktiske købstips.',
  metaAboutTitle: 'Om AllChinaBuy Spreadsheet – Ressourcehub',
  metaAboutDesc: 'Lær om AllChinaBuy Spreadsheet ressourcehub. Uafhængig researchplatform for produktdiscovery, sælgeranmeldelser og købsguider.',
  metaContactTitle: 'Kontakt AllChinaBuy Spreadsheet – Hold Forbindelsen',
  metaContactDesc: 'Kontakt AllChinaBuy Spreadsheet teamet med spørgsmål, forslag eller ressourceanmodninger.',
  metaSafetyTitle: 'Sikkerhedscenter – AllChinaBuy Spreadsheet Shopping Tips',
  metaSafetyDesc: 'Bliv sikker mens du researche AllChinaBuy. Lær om konto-sikkerhed, betalingsbevidsthed, phishing-prævention og sikker browsing.',
  metaArticleTitle: 'AllChinaBuy Spreadsheet Guide – Købsressourcer & Tips',
  metaArticleDesc: 'Detaljerede guider og artikler om AllChinaBuy Spreadsheet ressourcer, købstips, forsendelsesomkostninger og sælgerresearch.',
  relatedArticles: 'Relaterede Artikler',
  backToHome: 'Tilbage til Hjem',
  feature: 'Funktion',
  option: 'Mulighed',
  bestFor: 'Bedst Til',
  shippingMethod: 'Forsendelsesmetode',
  speed: 'Hastighed',
  cost: 'Omkostning',
  tracking: 'Sporing',
  seller: 'Sælger',
  category: 'Kategori',
  price: 'Pris',
  notes: 'Noter',
  warehouse: 'Lager',
  function: 'Funktion',
  storage: 'Opbevaring',
  qc: 'QC',
  lastModified: '2026-08-25',
  author: 'Redaktionelt Team',
  published: 'Udgivet',
  lastUpdated: 'Senest Opdateret',
  tableOfContents: 'Indholdsfortegnelse',
  quickAnswer: 'Hurtigt Svar',
  detailedExplanation: 'Detaljeret Forklaring',
  practicalGuide: 'Praktisk Guide',
  prosAndCons: 'Fordele & Ulemper',
  commonMistakes: 'Almindelige Fejl',
  safetyNotes: 'Sikkerhedsnoter',
  faq: 'FAQ',
  ctaFunnel: 'Fortsæt med at udforske AllChinaBuy ressourcer eller besøg vores hovedsiden for flere produkter.',
  visitMain: 'Besøg Hovedsiden',
  spreadsheetGuide: 'Komplet AllChinaBuy Spreadsheet Guide',
  couponDesc: 'Opdag de seneste AllChinaBuy kuponer, rabatkoder, tilbudsaktiviteter og hvordan du anvender dem for at spare på dine ordrer.',
  warehouseDesc: 'Forstå AllChinaBuy lageroperationer, lagerprocesser, QC-procedurer og hvordan lagerstyring fungerer.',
  qcDesc: 'Lær at læse QC-fotos, inspicere produkter, identificere kvalitetsproblemer og træffe informerede beslutninger før forsendelse.',
  spreadsheetGuideDesc: 'En omfattende guide til at forstå og bruge AllChinaBuy Spreadsheet til produktresearch og købsbeslutninger.',
  featuredProducts: 'Udvalgte Produkter',
  featuredProductsDesc: 'Gennemse vores udvalg af populære produkter fra AllChinaBuy Spreadsheet. Klik på et element for at købe nu.',
  viewAllProducts: 'Se Alle Produkter',
  buyNow: 'Køb Nu',
  productCatalog: 'Produktkatalog',
  productCatalogDesc: 'Gennemse vores udvalg af produkter fra AllChinaBuy Spreadsheet. Klik på et element for at købe direkte.',
  allProducts: 'Alle Produkter',
  items: 'varer',
  noProducts: 'Ingen produkter i denne kategori.',
  lookingForMore: 'Leder du Efter Flere Produkter?',
  visitFullStore: 'Besøg den Fulde Butik',
  heroTrustUpdated: 'Opdaterede ressourcer',
  heroTrustPractical: 'Praktiske guider',
  heroTrustResearch: 'Produktresearch',
  categoryBrowseDesc: 'Gennemse produktkategorier og udforsk AllChinaBuy Spreadsheet',
  showLess: 'Vis Mindre',
  showAllCategories: 'Vis Alle Kategorier',
  resourceCardDesc: 'Udforsk ressourcer og guider til',
  articlesDesc: 'Seneste artikler om AllChinaBuy Spreadsheet, købsguider og produktresearch',
  shippingDisclaimer: 'Tjek aktuelle oplysninger før køb. Leveringstider og omkostninger kan variere.',
  latestResources: 'Seneste Ressourcer',
  email: 'Email',
  responseTime: 'Svartid',
  website: 'Hjemmeside',
  sendMessage: 'Send Besked',
  fillRequired: 'Udfyld venligst alle obligatoriske felter.',
  messageTooLong: 'Beskeden må højst være 500 tegn.',
  thankYouMessage: 'Tak for din besked! Vi vender tilbage til dig snart.',
  safeBrowsingChecklist: 'Sikker Browsing Checkliste',
  verifyHTTPS: 'Verificer HTTPS',
  verifyHTTPSDesc: 'Tjek altid for hængelåsikonet og HTTPS-præfikset, før du indtaster personlige oplysninger.',
  strongPasswords: 'Brug Stærke Adgangskoder',
  strongPasswordsDesc: 'Opret unikke adgangskoder med en blanding af bogstaver, tal og symboler. Overvej en adgangskodeadministrator.',
  twoFactorAuth: 'Aktiver To-Faktor-Autentificering',
  twoFactorAuthDesc: 'Tilføj et ekstra sikkerhedslag til dine konti, når platformen understøtter det.',
  researchBeforeBuy: 'Research Før du Køber',
  researchBeforeBuyDesc: 'Tag dig tid til at læse sælgeranmeldelser, sammenligne priser og verificere produktdetaljer, før du køber.',
  keepRecords: 'Behold Dokumentation',
  keepRecordsDesc: 'Gem ordrebekræftelser, trackingnumre og kommunikation med sælgere til reference.',
  reportSuspicious: 'Anmeld Mistænkelig Aktivitet',
  reportSuspiciousDesc: 'Hvis du støder på mistænkelige sælgere, falske hjemmesider eller phishing-forsøg, anmeld dem straks.',
  safetyDisclaimer: 'Disse sikkerhedsoplysninger er til uddannelsesformål. Vi kan ikke garantere sikkerheden for nogen platform, sælger eller transaktion. Foretag altid din egen research.',
  pageNotFound: 'Side ikke fundet',
  pageNotFoundDesc: 'Den side du leder efter findes ikke eller er blevet flyttet.',
  productCardDesc: 'Udforsk ressourcer og guider til',
};